var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            "custom-class": "",
            "close-on-click-modal": false,
            visible: _vm.innerVisible,
            title: _vm.$t("AdvancePayment.InitializeBalance"),
            width: "1120px"
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: function($event) {
              _vm.innerVisible = false
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid",
              staticStyle: { padding: "0" }
            },
            [
              _c("cargo-ag-grid", {
                style: { width: "100%", height: "500px" },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "confirm" },
                  on: { click: _vm.confirm }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function() {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }